export type FleetAssetStatus = "active" | "maintenance" | "out_of_service";

export type ServiceUrgency = "none" | "ok" | "due_soon" | "overdue";

export interface FleetAssetRecord {
  id: string;
  unit: string;
  fleetGroup: string;
  vehicleType: string;
  equipment: string;
  /** Display label kept for older UI references. */
  assetType: string;
  assignedDriver: string;
  odometer: string;
  ownership: string;
  vin: string;
  fleetioStatus: string;
  status: FleetAssetStatus;
  serviceUrgency: ServiceUrgency;
  nextServiceDue: string;
  nextServiceTask: string;
  openIssues: number;
  openWorkOrders: number;
  fleetioId: string;
  notes: string;
  updatedAt: string;
}

export interface FleetListMeta {
  fleetio: boolean;
  quickmanage: boolean;
  overlay: boolean;
}

export function defaultFleetAsset(partial: Partial<FleetAssetRecord> & Pick<FleetAssetRecord, "id" | "unit">): FleetAssetRecord {
  const vehicleType = partial.vehicleType ?? partial.assetType ?? "";
  const equipment = partial.equipment ?? partial.assetType ?? vehicleType;
  return {
    id: partial.id,
    unit: partial.unit,
    fleetGroup: partial.fleetGroup ?? "",
    vehicleType,
    equipment,
    assetType: partial.assetType ?? ([vehicleType, equipment].filter(Boolean).join(" · ") || "Vehicle"),
    assignedDriver: partial.assignedDriver ?? "",
    odometer: partial.odometer ?? "",
    ownership: partial.ownership ?? "",
    vin: partial.vin ?? "",
    fleetioStatus: partial.fleetioStatus ?? "",
    status: partial.status ?? "active",
    serviceUrgency: partial.serviceUrgency ?? "none",
    nextServiceDue: partial.nextServiceDue ?? "",
    nextServiceTask: partial.nextServiceTask ?? "",
    openIssues: partial.openIssues ?? 0,
    openWorkOrders: partial.openWorkOrders ?? 0,
    fleetioId: partial.fleetioId ?? "",
    notes: partial.notes ?? "",
    updatedAt: partial.updatedAt ?? new Date().toISOString(),
  };
}
